import types from '../types'
import Action from '../../types/Action'

const initialState = {
  locationApplications: {
    loading: true,
    error: false,
    success: false,
    data: [],
  },
  locationApplication: {
    loading: false,
    error: false,
    success: false,
    data: null as any
  },
  addLocationApplication: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  updateGeneralInfo: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  updateContactInfo: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  updateOrgInfo: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  updateApplicationItem: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  updateApplicationCertification: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  submitApplication: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  submitCertification: {
    loading: false,
    error: false,
    success: false,
    data: []
  }
}

const locationApplicationReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case types.GET_LOCATION_APPLICATIONS_REQUESTED: {
      return {
        ...state,
        locationApplications: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    } case types.GET_LOCATION_APPLICATIONS_FULFILLED: {
      return {
        ...state,
        locationApplications: {
          ...state.locationApplications,
          loading: false,
          error: false,
          success: false,
          data: action.payload
        }
      }
    } case types.GET_LOCATION_APPLICATIONS_REJECTED: {
      return {
        ...state,
        locationApplications: {
          ...state.locationApplications,
          loading: false,
          error: action.payload
        }
      }
    } case types.GET_LOCATION_APPLICATION_REQUESTED: {
      return {
        ...state,
        locationApplication: {
          loading: true,
          error: false,
          success: false,
          data: null
        }
      }
    }
    case types.GET_LOCATION_APPLICATION_FULFILLED: {
      return {
        ...state,
        locationApplication: {
          ...state.locationApplication,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
    case types.GET_LOCATION_APPLICATION_REJECTED: {
      return {
        ...state,
        locationApplication: {
          ...state.locationApplication,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.ADD_LOCATION_APPLICATION_REQUESTED: {
      return {
        ...state,
        addLocationApplication: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.ADD_LOCATION_APPLICATION_FULFILLED: {
      return {
        ...state,
        addLocationApplication: {
          ...state.addLocationApplication,
          loading: false,
          success: true,
          data: action.payload
        },
        locationApplication: {
          ...state.locationApplication,
          data: action.payload
        },
        locationApplications: {
          ...state.locationApplications,
          data: [...state.locationApplications.data, action.payload]
        }
      }
    }
    case types.ADD_LOCATION_APPLICATION_REJECTED: {
      return {
        ...state,
        addLocationApplication: {
          ...state.addLocationApplication,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.ADD_LOCATION_APPLICATION_RESET: {
      return {
        ...state,
        addLocationApplication: {
          loading: false,
          error: false,
          success: false,
          data: null
        }
      }
    }
    case types.UPDATE_LOCATION_APPLICATION_GENERAL_INFO_REQUESTED: {
      return {
        ...state,
        updateGeneralInfo: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.UPDATE_LOCATION_APPLICATION_GENERAL_INFO_FULFILLED: {
      return {
        ...state,
        updateGeneralInfo: {
          ...state.updateGeneralInfo,
          loading: false,
          success: true,
          data: action.payload
        },
        locationApplication: {
          ...state.locationApplication,
          data: action.payload
        }
      }
    }
    case types.UPDATE_LOCATION_APPLICATION_GENERAL_INFO_REJECTED: {
      return {
        ...state,
        updateGeneralInfo: {
          ...state.updateGeneralInfo,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_LOCATION_APPLICATION_CONTACT_INFO_REQUESTED: {
      return {
        ...state,
        updateContactInfo: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.UPDATE_LOCATION_APPLICATION_CONTACT_INFO_FULFILLED: {
      return {
        ...state,
        updateContactInfo: {
          ...state.updateContactInfo,
          loading: false,
          success: true,
          data: action.payload
        },
        locationApplication: {
          ...state.locationApplication,
          data: action.payload.locationApplication
        }
      }
    }
    case types.UPDATE_LOCATION_APPLICATION_CONTACT_INFO_REJECTED: {
      return {
        ...state,
        updateContactInfo: {
          ...state.updateContactInfo,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_LOCATION_APPLICATION_ORG_INFO_REQUESTED: {
      return {
        ...state,
        updateOrgInfo: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.UPDATE_LOCATION_APPLICATION_ORG_INFO_FULFILLED: {
      return {
        ...state,
        updateOrgInfo: {
          ...state.updateOrgInfo,
          loading: false,
          success: true,
          data: action.payload
        },
        locationApplication: {
          ...state.locationApplication,
          data: action.payload
        }
      }
    }
    case types.UPDATE_LOCATION_APPLICATION_ORG_INFO_REJECTED: {
      return {
        ...state,
        updateOrgInfo: {
          ...state.updateOrgInfo,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_LOCATION_APPLICATION_ITEM_REQUESTED: {
      return {
        ...state,
        updateApplicationItem: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.UPDATE_LOCATION_APPLICATION_ITEM_FULFILLED: {
      return {
        ...state,
        updateApplicationItem: {
          ...state.updateApplicationItem,
          loading: false,
          success: true,
          data: action.payload
        },
        locationApplication: {
          ...state.locationApplication,
          data: action.payload
        }
      }
    }
    case types.UPDATE_LOCATION_APPLICATION_ITEM_REJECTED: {
      return {
        ...state,
        updateApplicationItem: {
          ...state.updateApplicationItem,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_LOCATION_APPLICATION_CERTIFICATION_REQUESTED: {
      return {
        ...state,
        updateApplicationCertification: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.UPDATE_LOCATION_APPLICATION_CERTIFICATION_FULFILLED: {
      return {
        ...state,
        updateApplicationCertification: {
          ...state.updateApplicationCertification,
          loading: false,
          success: true,
          data: action.payload
        },
        locationApplication: {
          ...state.locationApplication,
          data: action.payload
        }
      }
    }
    case types.UPDATE_LOCATION_APPLICATION_CERTIFICATION_REJECTED: {
      return {
        ...state,
        updateApplicationCertification: {
          ...state.updateApplicationCertification,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.SUBMIT_LOCATION_APPLICATION_REQUESTED: {
      return {
        ...state,
        submitApplication: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.SUBMIT_LOCATION_APPLICATION_FULFILLED: {
      return {
        ...state,
        submitApplication: {
          ...state.submitApplication,
          loading: false,
          success: true,
          data: action.payload
        },
        locationApplication: {
          ...state.locationApplication,
          data: action.payload
        }
      }
    }
    case types.SUBMIT_LOCATION_APPLICATION_REJECTED: {
      return {
        ...state,
        submitApplication: {
          ...state.submitApplication,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.SUBMIT_LOCATION_CERTIFICATION_ITEMS_REQUESTED: {
      return {
        ...state,
        submitCertification: {
          loading: true,
          error: false,
          success: false,
          data: []
        }
      }
    }
    case types.SUBMIT_LOCATION_CERTIFICATION_ITEMS_FULFILLED: {
      return {
        ...state,
        submitCertification: {
          ...state.submitCertification,
          loading: false,
          success: true,
          data: action.payload
        },
        locationApplication: {
          ...state.locationApplication,
          data: action.payload
        }
      }
    }
    case types.SUBMIT_LOCATION_CERTIFICATION_ITEMS_REJECTED: {
      return {
        ...state,
        submitCertification: {
          ...state.submitCertification,
          loading: false,
          error: action.payload
        }
      }
    }
    default:
      return state
  }
}

export default locationApplicationReducer